export default __webpack_public_path__ + "static/media/dark-checkers.b33223f2.png";